module.exports = __webpack_public_path__ + "img/login_right.948f44ae.png";